import { exists } from '../../../../common/utilities/utilitiesFunctions';

export const isShiftlineEmployeeStopped = (shiftline) => {
    const currentOwner = shiftline.currentOwner;

    if (!currentOwner) {
        return false;
    }

    const stoppedState = shiftline.currentOwner.states.find((x) => x.status === 2);
    if (!stoppedState) {
        return false;
    }

    return new Date(stoppedState.endDate) < new Date();
}

export const getRowCssClass = (rowData, editMode) => {
    if (exists(rowData)) {
        const isDisabled = rowData.isDisabled ? 'row-marked-disabled' : '';
        const color = (!exists(rowData.IsNew) && editMode && !isDisabled) ? 'new-row-color' : '';
        const backgroundColor = (exists(rowData.parentId) || exists(rowData.editMode)) && (rowData.parentId || rowData.editMode) ? 'new-row-background-color' : '';
        const display = exists(rowData.markedForDeletion) && rowData.markedForDeletion ? 'new-row-markedForDeletion-display' : '';

        return `workplan-shiftline-table-row ${color} ${isDisabled} ${backgroundColor} ${display}`;
    }
    return '';


}
